import { AccountCapabilitiesCardAllowanceIntervalEnum } from '../interfaces/CardsGatewayAutogenerated';
export * from '../interfaces/CardsGatewayAutogenerated';
/**
 * This is the sort order of the interval options from {@link AccountCapabilitiesCardAllowanceIntervalEnum} on the UI (in the card issuing modal).
 * It should be updated if the enum gets new values
 */
export const CAPABILITIES_INTERVAL_ORDER = [
    AccountCapabilitiesCardAllowanceIntervalEnum.Continuous,
    AccountCapabilitiesCardAllowanceIntervalEnum.Daily,
    AccountCapabilitiesCardAllowanceIntervalEnum.Weekly,
    AccountCapabilitiesCardAllowanceIntervalEnum.Monthly
];
/**
 * The actual logical card type.
 * For the display version, see {@link CARD_TYPES}
 */
export var CardType;
(function (CardType) {
    CardType["Physical"] = "physical";
    CardType["Ghost"] = "ghost";
    CardType["Virtual"] = "virtual";
})(CardType || (CardType = {}));
export const CreateCardOptions = Object.assign(Object.assign({}, CardType), { BulkOrder: 'bulk' });
const CreateCardValues = Object.values(CreateCardOptions);
/**
 * The card type that users see (they do not distinguish between virtual and ghost cards).
 * This is just a map of the values in the corresponding TS type ({@link CARD_TYPES}).
 * For the logical version, see {@link CardType}
 */
export const GATEWAY_EMBURSE_CARD_TYPE = {
    PHYSICAL: 'PHYSICAL',
    DIGITAL: 'DIGITAL'
};
/**
 * The include options supported by the issuing_details endpoint
 */
export var AbacusIssuingDetailsInclude;
(function (AbacusIssuingDetailsInclude) {
    AbacusIssuingDetailsInclude["shared_link"] = "shared_link";
    AbacusIssuingDetailsInclude["full_digital_shared_link"] = "full_digital_shared_link";
    AbacusIssuingDetailsInclude["json_shared_link"] = "json_shared_link";
    AbacusIssuingDetailsInclude["expense_tags"] = "expense_tags";
})(AbacusIssuingDetailsInclude || (AbacusIssuingDetailsInclude = {}));
/**
 * Short form display names for the card allowance intervals in {@link AccountCapabilitiesCardAllowanceIntervalEnum}.
 * For longer versions, see {@link INTERVAL_LONG_DISPLAY_NAMES}
 */
export const INTERVAL_SHORT_DISPLAY_NAMES = {
    [AccountCapabilitiesCardAllowanceIntervalEnum.Daily]: 'daily',
    [AccountCapabilitiesCardAllowanceIntervalEnum.Weekly]: 'weekly',
    [AccountCapabilitiesCardAllowanceIntervalEnum.Monthly]: 'monthly',
    [AccountCapabilitiesCardAllowanceIntervalEnum.Continuous]: 'non-recurring'
};
/**
 * Long form display names for the card allowance intervals in {@link AccountCapabilitiesCardAllowanceIntervalEnum}.
 * For shorter versions, see {@link INTERVAL_SHORT_DISPLAY_NAMES}
 */
export const INTERVAL_LONG_DISPLAY_NAMES = {
    [AccountCapabilitiesCardAllowanceIntervalEnum.Daily]: 'daily recurring',
    [AccountCapabilitiesCardAllowanceIntervalEnum.Weekly]: 'weekly recurring',
    [AccountCapabilitiesCardAllowanceIntervalEnum.Monthly]: 'monthly recurring',
    [AccountCapabilitiesCardAllowanceIntervalEnum.Continuous]: 'non-recurring'
};
